import React from 'react'
import { ResponsiveBox } from '@usap/uicomponents'
import Desktop from './sortByComponents/Desktop'
import Mobile from './sortByComponents/Mobile'

export default function SortBy(props) {
  const { toggleItemsPerPage } = props

  return (
    <>
      <ResponsiveBox id="sortByContainer" fxIf={{ large: true, other: false }}>
        <Desktop toggleItemsPerPage={toggleItemsPerPage} />
      </ResponsiveBox>
      <ResponsiveBox id="sortByContainer" fxIf={{ large: false, other: true }}>
        <Mobile toggleItemsPerPage={toggleItemsPerPage} />
      </ResponsiveBox>
    </>
  )
}
